<div *ngIf="!json" class="text-muted small">—</div>

<ng-container *ngIf="root">
  <ng-container *ngTemplateOutlet="sectionTemplate; context: { $implicit: root, depth: 0 }"></ng-container>
</ng-container>

<div *ngIf="plainText" class="small text-break">{{ plainText }}</div>

<div *ngIf="json && root" class="mt-2">
  <button type="button" class="btn btn-link btn-sm p-0 text-muted" (click)="showRaw = !showRaw">
    <i class="bx" [ngClass]="showRaw ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
    {{ showRaw ? 'Ham veriyi gizle' : 'Ham veriyi göster' }}
  </button>
  <pre *ngIf="showRaw" class="bg-light border rounded p-2 small mt-1 mb-0" style="max-height: 300px">{{ rawJson }}</pre>
</div>

<ng-template #sectionTemplate let-section let-depth="depth">
  <div [ngClass]="{ 'border-start ps-3 mt-2': depth > 0 }">
    <div *ngIf="section.title" class="fw-semibold small mb-1">{{ section.title }}</div>

    <table class="table table-sm table-borderless small mb-1" *ngIf="section.fields.length">
      <tbody>
        <tr *ngFor="let field of section.fields">
          <td class="text-muted text-nowrap py-0" style="width: 1%">{{ field.label }}</td>
          <td class="py-0 text-break">{{ field.value }}</td>
        </tr>
      </tbody>
    </table>

    <div *ngFor="let table of section.tables" class="mt-2">
      <div class="fw-semibold small mb-1">{{ table.title }}</div>
      <div class="table-responsive">
        <table class="table table-sm table-bordered small mb-1">
          <thead class="table-light">
            <tr><th>#</th><th *ngFor="let column of table.columns">{{ column }}</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of table.rows; let i = index">
              <td>{{ i + 1 }}</td>
              <td *ngFor="let cell of row">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ng-container *ngFor="let child of section.sections">
      <ng-container *ngTemplateOutlet="sectionTemplate; context: { $implicit: child, depth: depth + 1 }"></ng-container>
    </ng-container>
  </div>
</ng-template>
